@import '../../../../../../../constants/spacing.module.less';
@import '../../new-lineup-plan-grid-shared-styles.module.less';

.plan-user-count {
  display: grid;
  grid-template-rows: subgrid;
  grid-template-columns: subgrid;
  grid-row: @user-count-label-grid-area / @user-count-grid-area;
  gap: @space-0;
}

.read-only-users {
  grid-area: @user-count-grid-area;
  display: flex;
  align-items: center;
  color: var(--gray-212c36);
}

.user-input {
  grid-area: @user-count-grid-area;
  height: 32px;
  gap: @space-4;
  padding: @space-4 @space-4 @space-4 @space-8;
  font-size: 14px;

  // not thrilled about this, but avoids having to refactor `NumberInput` for now
  > input {
    text-align: left;
  }
}
